/** @format */

import React, { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toast } from 'react-toastify';
import { grey } from "@mui/material/colors";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

const actionColumn = [
  {
    field: "action",
    headerName: "Action",
    width: 150,
    renderCell: () => {
      return (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" size="small">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      );
    },
  },
];

const DataTable = ({ rows, columns, updateList, deleteList }) => {
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  function handleDelete() {
    const newList = rows.filter((row) => {
      if (!rowSelectionModel.includes(row.id)) {
        return row;
      }
    });
    console.log(newList);
    updateList(newList);
    toast.success(`Items successfully deleted`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      });
    deleteList(rowSelectionModel)
  }

  useEffect(() => {
    console.log(rowSelectionModel);
  }, [rowSelectionModel]);

  return (
    <>
      <Box sx={{ height: "85%", width: "85%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
            density: "compact",
          }}
          pageSizeOptions={[5, 10]}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          disableRowSelectionOnClick
          disableDensitySelector
          disableColumnSelector
          checkboxSelection
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
          getRowSpacing={(params) => ({
            top: params.isFirstVisible ? 0 : 2,
            bottom: params.isLastVisible ? 0 : 2,
          })}
          sx={{
            boxShadow: 2,
            /*border: 1,
                    borderColor: 'primary.light',*/
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            [`& .${gridClasses.row}`]: {
              bgcolor: (theme) =>
                theme.palette.mode === "light" ? grey[200] : grey[900],
            },
            [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
              {
                outline: "none",
              },
            [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
              {
                outline: "none",
              },
          }}
        />

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          sx={{ transform: "translateY(19px)" }}
        >
          <Button
            variant="contained"
            onClick={handleDelete}
            disabled={rowSelectionModel.length === 0}
            startIcon={<DeleteForeverIcon/>}
          >
            Delete
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default DataTable;
